// extracted by mini-css-extract-plugin
module.exports = {"left":"ZetyManagement-module--left--91Z1S","leftHeading":"ZetyManagement-module--leftHeading--2j-1o"};